export const ordinalize = (number: number): string => {
  const value = Math.abs(number) % 100;
  const suffixes = ["th", "st", "nd", "rd"];
  const suffix = suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0];
  return number + suffix;
};
